import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';

interface ChartData {
  amount: number[];
  serial_number: string[];
  caught_empty_amount?: number[];
}

interface SeriesData {
  name: string;
  data: number[];
}

export const allTrapsActivityBarChartOptions = (chartData: ChartData, t: TFunction, isMobile: boolean) => {
  const series: SeriesData[] = [];

  series.push({
    name: t('ChartsAnalitics.all_traps_activity_chart.data_labels'),
    data: chartData.amount || [],
  });
  series.push({
    name: t('ChartsAnalitics.all_traps_activity_chart.data_labels_non_capture'),
    data: chartData.caught_empty_amount || [],
  });

  const isManyItems = chartData.serial_number.length > 20;

  const chartOptions: ApexOptions = {
    series: series,
    chart: {
      height: 350,
      type: 'bar',
      stacked: true,
      zoom: {
        enabled: true,
      },
      toolbar: {
        show: true,
      },
    },
    markers: {
      size: 3,
      shape: 'circle',
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: isMobile ? '95%' : '80%',
        barHeight: '80%',
        dataLabels: {
          total: {
            enabled: !isManyItems,
            style: {
              fontSize: isManyItems ? '10px' : '13px',
              fontWeight: 500,
              color: '#4f555c',
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: !isManyItems,
      style: { fontSize: '12px', fontWeight: 600, colors: ['#fff'] },
    },
    xaxis: {
      title: {
        text: t('ChartsAnalitics.all_traps_activity_chart.x_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      categories: chartData.serial_number || [],
      labels: {
        style: {
          colors: '#9aa0ac',
        },
      },
    },
    yaxis: {
      stepSize: 2,
      decimalsInFloat: 0,
      title: {
        text: t('ChartsAnalitics.all_traps_activity_chart.y_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      labels: {
        style: {
          colors: '#9aa0ac',
        },
      },
    },
    grid: {
      borderColor: '#f1f3fa',
    },
    fill: {
      opacity: 1,
    },
    colors: ['#6A37D4', '#FFE529'],
  };

  return chartOptions;
};
